import { VueModule } from '@Foundation/utilities';
import GenericBannerYoutubePlayer from './code/Scripts/components/generic-banner-youtube-player.vue';

export default VueModule({
    components: {
        GenericBannerYoutubePlayer
    }
});
